import React from "react";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4F1EA] p-5" data-testid="payment-cancel-page">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-xl">
        <XCircle className="mx-auto h-14 w-14 text-slate-400" />
        <h1 className="mt-5 font-head text-2xl font-bold text-navy">Pagamento annullato</h1>
        <p className="mt-2 text-sm text-slate-500">Nessun addebito effettuato. Puoi rinnovare quando vuoi.</p>
        <a href="/" className="mt-6 inline-block rounded-lg bg-navy px-6 py-3 font-semibold text-white hover:bg-navy-hover">Torna all'app</a>
      </div>
    </div>
  );
}
